import { Alert, Box, Divider, LinearProgress, Typography } from "@mui/material";
import { Button } from "../../shared";

//@ts-ignore
import Logo from "../../assets/images/logo_v2.svg";
import { Link } from "react-router-dom";

export function PasswordFirewall(props: any) {
    return (
        <Backdrop open={true}>
            <form
                style={{
                    maxWidth: 340,
                    padding: 8,
                }}
            >
                <div style={{ marginBottom: 20 }}>
                    <Link to="/notedrop">
                        <img style={{ width: 56 }} draggable={true} src={Logo} alt="nithinpb.com logo" />
                    </Link>
                    <Typography
                        variant="body2"
                        sx={{ color: "rgba(255,255,255,0.8)", mt: 1.5, lineHeight: 1.7 }}
                        component={"div"}
                    >
                        Share notes effortlessly with{" "}
                        <Link to={"/notedrop"} style={{ color: "#a5b4fc", textDecoration: "none" }}>
                            NoteDrop!
                        </Link>
                        <br />
                        Let's stay organized together.
                    </Typography>
                </div>
                <Box sx={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, overflow: "hidden" }}>
                    {props.isLoading ? <LinearProgress sx={{ borderRadius: 2 }} /> : <Box sx={{ height: 4 }}></Box>}
                </Box>
                <Divider sx={{ mb: 2, background: "rgba(255, 255, 255, 0.08)" }} />
                <Input {...props} />
                <Button
                    variant={"contained"}
                    color={"warning"}
                    type={"button"}
                    sx={{
                        borderRadius: "14px",
                        mt: 2,
                        width: "100%",
                        textTransform: "none",
                        fontWeight: 600,
                        py: 1.5,
                    }}
                    onClick={props.onFetch}
                    size={"large"}
                    disabled={!props.value}
                >
                    {props.isLoading ? "Retrieving note..." : "Retrieve note"}
                </Button>
                <Alert
                    severity={props.error ? "error" : "warning"}
                    sx={{
                        borderRadius: "14px",
                        mt: 3,
                        fontSize: 13,
                    }}
                    variant="outlined"
                >
                    <Typography sx={{ fontSize: 13 }}>
                        {props.incorrectPassword
                            ? "Incorrect password! Please try again."
                            : props.error
                              ? "Something went wrong! Please check your connection."
                              : "This note is protected with a password."}
                    </Typography>
                </Alert>
            </form>
        </Backdrop>
    );
}

function Backdrop(props: any) {
    return (
        <div
            style={{
                background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 150000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100vw",
                height: "100vh",
            }}
            className="password-firewall-backdrop"
            data-bg-text="Note Drop"
        >
            {props.children}
        </div>
    );
}

function Input(props: any) {
    return (
        <div>
            <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: 13, fontWeight: 600, mb: 1 }}>
                Password
            </Typography>
            <input
                value={props.value || ""}
                onChange={props.onChange}
                placeholder="*********"
                type={"password"}
                style={{
                    borderRadius: 14,
                    border: "1px solid rgba(255,255,255,0.15)",
                    outline: "none",
                    fontSize: 16,
                    fontWeight: 600,
                    padding: "14px 18px",
                    fontFamily: "var(--fq-font-family)",
                    width: "100%",
                    background: "rgba(255,255,255,0.06)",
                    color: "#fff",
                    transition: "var(--fq-transition-smooth)",
                }}
            />
        </div>
    );
}
